import AppConstants from "@/constants/AppConstants";
import {
  TEXT_STYLE,
  TEXT_COLOR,
  TEXT_FONT,
  TEXT_SIZE,
  TEXT_LINE_HEIGHT,
  TEXT_LETTER_SPACING,
  TEXT_LETTER_CASE,
  TEXT_ALIGNMENT,
  TEXT_COLUMNS,
  TEXT_COLUMNS_GAP,
  TEXT_OVERFLOW,
  TEXT_FORMAT,
  TEXT_HOVER_COLOR,
  TEXT_HOVER_FORMAT,
  TEXT_LINK_COLOR,
  TEXT_LINK_FORMAT,
  TEXT_LINK_HOVER_COLOR,
  TEXT_LINK_HOVER_FORMAT,
} from "@/constants/MergeConstants";

const {
  ALIGN_LEFT,
  TEXT_LETTER_CASE_UPPERCASE,
  TEXT_LETTER_CASE_LOWERCASE,
  TEXT_LETTER_CASE_CAPITALIZE,
  TEXT_FORMAT_UNDERLINE,
  TEXT_FORMAT_NONE,
  TEXT_OVERFLOW_DISPLAY,
  TEXT_OVERFLOW_SINGLE_LINE,
  TEXT_OVERFLOW_SINGLE_LINE_ELLIPSIS,
  TEXT_OVERFLOW_CROP,
  TEXT_STYLE_PARAGRAPH,
  TEXT_TRANSFORM_UNSET_VALUE,
} = AppConstants;

export const DEFAULT_TEXT_VALUES = {
  [TEXT_STYLE]: TEXT_STYLE_PARAGRAPH,
  [TEXT_COLOR]: "colors-0",
  [TEXT_FONT]: "arial",
  [TEXT_SIZE]: 16,
  [TEXT_LINE_HEIGHT]: 1,
  [TEXT_LETTER_SPACING]: 0,
  [TEXT_LETTER_CASE]: TEXT_TRANSFORM_UNSET_VALUE,
  [TEXT_ALIGNMENT]: ALIGN_LEFT,
  [TEXT_COLUMNS]: 1,
  [TEXT_COLUMNS_GAP]: 0,
  [TEXT_OVERFLOW]: TEXT_OVERFLOW_DISPLAY,
  [TEXT_FORMAT]: TEXT_FORMAT_NONE,
  [TEXT_HOVER_COLOR]: "colors-0",
  [TEXT_HOVER_FORMAT]: TEXT_FORMAT_NONE,
  [TEXT_LINK_COLOR]: "colors-0",
  [TEXT_LINK_FORMAT]: TEXT_FORMAT_NONE,
  [TEXT_LINK_HOVER_COLOR]: "colors-0",
  [TEXT_LINK_HOVER_FORMAT]: TEXT_FORMAT_NONE,
};

export const LETTER_CASE_OPTIONS = [
  { value: TEXT_TRANSFORM_UNSET_VALUE, label: "Normal" },
  { value: TEXT_LETTER_CASE_UPPERCASE, label: "Uppercase" },
  { value: TEXT_LETTER_CASE_LOWERCASE, label: "Lowercase" },
  { value: TEXT_LETTER_CASE_CAPITALIZE, label: "Capitalize" },
];

export const OVERFLOW_OPTIONS = [
  { value: TEXT_OVERFLOW_DISPLAY, label: "Display" },
  { value: TEXT_OVERFLOW_SINGLE_LINE, label: "Single Line" },
  { value: TEXT_OVERFLOW_SINGLE_LINE_ELLIPSIS, label: "Single Line with ellipses" },
  { value: TEXT_OVERFLOW_CROP, label: "Crop" },
];

export const FORMAT_OPTIONS = [
  { value: TEXT_FORMAT_UNDERLINE, label: "Underline" },
  { value: TEXT_FORMAT_NONE, label: "No Underline" },
];

export const HOVER_FORMAT_OPTIONS = [
  { value: TEXT_FORMAT_UNDERLINE, label: "Underline" },
  { value: TEXT_FORMAT_NONE, label: "No Underline" },
];
